import { render, staticRenderFns } from "./ClaimAddWallet.vue?vue&type=template&id=6ae8818e&"
import script from "./ClaimAddWallet.vue?vue&type=script&lang=js&"
export * from "./ClaimAddWallet.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAddWallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports